import BannerPolicy from "./banner";
import PrivacyPolicyContent from "./content";
import { privacyPolicyData, groupContentTitleDtos } from "./data";
import TableContent from "./tab-content";
import "./content.scss";

const PrivacyPolicyPage = () => {
  return (
    <>
      <BannerPolicy />
      <div className="container_content">
        <div className="formContent container-xxl">
          <div className="formContentLeft">
            {privacyPolicyData?.map((section) => (
              <PrivacyPolicyContent
                data={section}
                key={section.pageSectionId}
              />
            ))}
          </div>
          <TableContent data={groupContentTitleDtos} />
        </div>
      </div>
    </>
  );
};

export default PrivacyPolicyPage;
